export default "__VITE_ASSET__e225453c__"